import React, { useState } from 'react';
import Popup from '../features/Popup';
import { appConfig } from '../../appConfig';

const Disclaimer = () => {
  const [showDPopup, setShowDPopup] = useState(false);
  const { Disclaimer } = appConfig;

  const toggledDPopup = () => {
    setShowDPopup(!showDPopup);
  };

  return (
    <div>
      <div className="maptext">
        <div className="coveredPowerdBy">{Disclaimer.poweredBy}</div>

        <span className="text-warning"> {Disclaimer.warningIcon} </span>
        {Disclaimer.shortText}

        <button
          onClick={toggledDPopup}
          className="border-0 bg-white text-primary font-weight-bold"
        >
          {Disclaimer.learnMoreText}
        </button>
      </div>

      <Popup
        show={showDPopup}
        handleClose={toggledDPopup}
        popUpHeading={Disclaimer.popupHeading}
      >
        {Disclaimer.popupContent.map((text, index) => (
          <p key={index}>{text}</p>
        ))}
      </Popup>
    </div>
  );
};

export default Disclaimer;
